(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSplide(root) {
    var el = root.querySelector('[data-dgt-announce]');
    if (!el || !window.Splide) return;
    var ext = (window.splide && window.splide.Extensions) ? window.splide.Extensions : {};
    var slideCount = el.querySelectorAll('.splide__slide').length;
    var cloneCount = Math.max(slideCount, Math.ceil(window.innerWidth / 80));
    var splide = new Splide(el, {
      type: 'loop',
      drag: 'free',
      arrows: false,
      pagination: false,
      autoWidth: true,
      gap: 0,
      focus: 0,
      perMove: 1,
      clones: cloneCount,
      autoScroll: {
        speed: parseFloat(root.dataset.speed) || 0.6,
        pauseOnHover: true,
        pauseOnFocus: false
      }
    });
    splide.mount(ext);

    var refresh = function () { splide.refresh(); };
    window.addEventListener('load', refresh);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    el.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', refresh, { once: true });
    });
  }

  function init(root) {
    if (root.dataset.dgtAnnounceReady === '1') return;
    root.dataset.dgtAnnounceReady = '1';
    initSplide(root);
  }

  function boot() {
    document.querySelectorAll('[data-dgt-announce-root]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-dgt-announce-root]');
    if (root) init(root);
  });
})();
